import React from 'react';
import parse from 'html-react-parser';

const SubpageContent = ({ content, style }) => {
  return <section style={style}>{parse(content)}</section>;
};

export default SubpageContent;
